// Data hooks for the budget app. Keeps API plumbing out of App.js.
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/budget";

export function useCategories() {
  const [data, setData] = useState({ categories: [], fixed: [], variable: [] });

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/categories`)
      .then((r) => {
        if (!alive) return;
        setData({
          categories: r.data.categories || [],
          fixed: r.data.fixed || [],
          variable: r.data.variable || [],
        });
      })
      .catch((e) => console.error("useCategories:", e));
    return () => { alive = false; };
  }, []);

  return data;
}

export function useBudget(month) {
  const [income, setIncome] = useState(0);
  const [refundsIncome, setRefundsIncome] = useState(0);
  const [savingsGoal, setSavingsGoal] = useState(1000);
  const [investments, setInvestments] = useState(0);
  const [expenses, setExpenses] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    axios.get(`${API}/budget/${month}`, { signal: controller.signal })
      .then((r) => {
        const d = r.data;
        setIncome(d.income || 0);
        setRefundsIncome(d.refunds_income || 0);
        setSavingsGoal(d.savings_goal || 0);
        setInvestments(d.investments || 0);
        setExpenses(d.expenses || {});
      })
      .catch((e) => {
        if (axios.isCancel(e) || e?.name === "CanceledError") return;
        console.error("useBudget:", e);
      })
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, [month]);

  return {
    income, setIncome,
    refundsIncome, setRefundsIncome,
    savingsGoal, setSavingsGoal,
    investments, setInvestments,
    expenses, setExpenses,
    loading,
  };
}

export function useAllBudgets() {
  const [budgets, setBudgets] = useState([]);

  const refresh = useCallback(() => {
    axios.get(`${API}/budgets`)
      .then((r) => setBudgets(r.data || []))
      .catch((e) => console.error("useAllBudgets:", e));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { budgets, refresh };
}
